<template>
    <div class="detail">
        <div class="header">
            <div class="left" @click="toIndex()">< 返回</div>
            <div class="span1">
                <span>投诉详情</span>
            </div>
            <div class="right"></div>
        </div>
        <div class="main">
			<div class="main-title">
				<img src="@/assets/img/serviceManager/complaint_detail_1.svg" alt="">
				<p>投诉情况</p>
			</div>
			<div class="main-li" v-for="(item,i) in list" :key="i+item.title">
				<p>{{item.title}}</p>
				<span :style="{color:item.title==='附件'?'#4991E1':''}">{{item.text}}</span>
			</div>
			<div class="main-title" style="margin-top:50px">
				<img src="@/assets/img/serviceManager/complaint_detail_2.svg" alt="">
				<p>处理情况</p>
			</div>
			<div class="main-li" v-for="(item,i) in list2" :key="i+item.title">
				<p>{{item.title}}</p>
				<span>{{item.text}}</span>
			</div>
		</div>
        
    </div>
</template>
<script>
import api from '@/api/wisdomSchool/index.js'
export default {
	props:['info'],
	components:{
        
    },
	data() {
		return {
			pageNum: 1,
			pageSize: 10,
			totalPage: 0,
			queryParams: {
				name: '',
				title: '',
			},
			tableData: [],
			list:[
				{title:'投诉编号',text:'158141641'},
				{title:'投诉类型',text:'教师投诉'},
				{title:'授课老师',text:'朱哈斯'},
				{title:'投诉人',text:'葛周魃'},
				{title:'投诉内容',text:'教师并没有如约开展课程，而是把课程改为了自习课'},
				{title:'附件',text:'20211116wechat.png'},
				{title:'投诉时间',text:'2021/11/16'},
			],
			list2:[
				{title:'状态',text:'已处理'},
				{title:'处理意见',text:'已核实相关情况，家长反馈属实，望学校妥善处理'},
			]
		}
	},
	computed:{

	},
	watch: {

	},
	created() {
		
	},
	methods: {
		async getDataList() {
			let params = {
				orgId:sessionStorage.getItem('orgId'),
				platformCode:sessionStorage.getItem('platformCode'),
				page:this.pageNum,
				limit:this.pageSize,
				classId:this.info.classId,
				courseName:this.queryParams.title,
				studentName:this.queryParams.name,
			}
			// let res= await api.studentCourseStatistics(params);
			// if(res.code==='0'){
			// 	this.tableData=res.data?.list || [];
			// 	this.totalPage=res.data?.total || 0;
			// }
			// console.log('学生分布详情',res)
		},
        toIndex(){
            this.$emit('to-index')
        },
	},
	mounted() {},
}
</script>
<style lang="less" scoped>
.detail {
	width: 100%;
    padding: 0px 30px 30px 30px;
	.header {
		height: 60px;
		line-height: 48px;
		margin-bottom: 20px;
		display: flex;
		justify-content: space-between;
        align-items: center;
		.span1 {
			font-family: 'PingFang SC Bold';
			font-size: 20px;
			color: #000;
			margin-right: 30px;
		}
        .left, .right{
            width: 60px;
        }
        .left{
            cursor: pointer;
        }
	}
	.main{
		width: 100%;
		height: 100%;
		.main-title{
			display: flex;
			align-items: center;
			p{
				font-weight: bold;
				font-size: 14px;
				color: #181c26;
				margin-left: 10px;
			}
		}
		.main-li{
			margin-top: 20px;
			width: 100%;
			display: flex;
			// align-items: center;
			font-size: 14px;
			color: #888;
			p{
				width: 120px;
				text-align: right;
				margin-right: 20px;
			}
			span{
				width: calc(100% - 150px);
				word-wrap:break-word;
			}
		}
	}
}
</style>
